import Pos from '@/components/pages/trackntrace/Pos'
import BusinessLocations from '@/components/pages/trackntrace/BusinessLocations'
import BusinessLocation from '@/components/pages/trackntrace/BusinessLocation'
import PackageTypes from '@/components/pages/trackntrace/package/PackageTypes'
import PackageEdit from '@/components/pages/trackntrace/package/PackageEdit'
import ListShipments from '@/components/pages/trackntrace/shipments/ListShipments'
import ReceiveShipment from '@/components/pages/trackntrace/shipments/ReceiveShipment'
import EditShipment from '@/components/pages/trackntrace/shipments/EditShipment'
import Shipment from '@/components/pages/trackntrace/shipments/Shipment'
import SupplyChainOverview from '@/components/pages/trackntrace/dashboards/SupplyChainOverview'
import EnableCodeRange from '@/components/pages/trackntrace/EnableCodeRange'
import RegisterTrackingevent from '@/components/pages/trackntrace/RegisterTrackingevent'
import Repackage from '@/components/pages/trackntrace/registration/Repackage'
import LocationPortal from '@/components/pages/trackntrace/dashboards/locationportal/LocationPortal'
import ByPackageType from '@/components/pages/trackntrace/dashboards/locationportal/components/ByPackageType'
import ByProduct from '@/components/pages/trackntrace/dashboards/locationportal/components/ByProduct'
import Events from '@/components/pages/trackntrace/dashboards/locationportal/components/Events'
import PackageFlow from '@/components/pages/trackntrace/dashboards/locationportal/components/PackageFlow'
import Recalled from '@/components/pages/trackntrace/dashboards/locationportal/components/Recalled'
import Returned from '@/components/pages/trackntrace/dashboards/locationportal/components/Returned'
import SoldConsumer from '@/components/pages/trackntrace/dashboards/locationportal/components/SoldConsumer'
import Trace from '@/components/pages/trackntrace/dashboards/trace/Trace'
import TraceMap from '@/components/pages/trackntrace/dashboards/trace/TraceMap'
import TreeRevisionList from '@/components/pages/trackntrace/dashboards/treerevision/TreeRevisionList'
import Recalls from '@/components/pages/trackntrace/configuration/recall/Recalls'
import Recall from '@/components/pages/trackntrace/configuration/recall/Recall'
import RecallCreate from '@/components/pages/trackntrace/configuration/recall/RecallCreate'

export default [
  {
    path: '/trackntrace/configuration/recall/new',
    component: RecallCreate,
    name: 'recallCreate',
    meta: {
      title: 'Do Recall',
      icon: 'fa fa-undo',
      breadcrumb: [
        { title: 'Recalls', path: '#/trackntrace/configuration/recalls' }
      ]
    }
  },
  {
    path: '/trackntrace/configuration/recall/:id',
    component: Recall,
    name: 'recall',
    meta: {
      title: 'Recall {{ params.id}}',
      icon: 'fa fa-undo',
      breadcrumb: [
        { title: 'Recalls', path: '#/trackntrace/configuration/recalls' }
      ]
    }
  },
  {
    path: '/trackntrace/configuration/recalls',
    component: Recalls,
    name: 'recalls',
    meta: {
      title: 'Recalls',
      icon: 'fa fa-undo'
    }
  },
  {
    path: '/trackntrace/dashboards/trees',
    component: TreeRevisionList,
    name: 'treeRevisionList',
    meta: {
      title: 'Tree Revisions',
      icon: 'fa fa-tree'
    }
  },
  {
    path: '/trackntrace/dashboards/trace/map/:code',
    component: TraceMap,
    name: 'traceMap',
    meta: {
      title: ' Trace Map',
      icon: 'fa fa-globe'
    }
  },
  {
    path: '/trackntrace/dashboards/trace',
    component: Trace,
    name: 'trace',
    meta: {
      title: 'Trace',
      icon: 'fa fa-truck'
    }
  },
  {
    path: '/trackntrace/dashboards/trace/:code',
    component: Trace,
    name: 'traceDetails',
    meta: {
      title: 'Trace',
      icon: 'fa fa-truck'
    }
  },
  {
    path: '/trackntrace/dashboards/locationportal/',
    component: LocationPortal,
    name: 'locationPortal',
    meta: {
      title: 'Location Portal',
      icon: 'fa fa-globe'
    },
    children: [{
      path: ':id/packagetype',
      component: ByPackageType,
      name: 'byPackageType',
      meta: {
        title: 'Location Portal - Packages',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/product',
      component: ByProduct,
      name: 'byProduct',
      meta: {
        title: 'Location Portal - Products',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/events',
      component: Events,
      name: 'events',
      meta: {
        title: 'Location Portal - Events',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/packageflow',
      component: PackageFlow,
      name: 'packageFlow',
      meta: {
        title: 'Location Portal - Package Flow',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/recalled',
      component: Recalled,
      name: 'recalled',
      meta: {
        title: 'Location Portal - Recalled',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/returned',
      component: Returned,
      name: 'returned',
      meta: {
        title: 'Location Portal - Returned',
        icon: 'fa fa-globe'
      }
    }, {
      path: ':id/soldconsumer',
      component: SoldConsumer,
      name: 'soldConsumer',
      meta: {
        title: 'Location Portal - Sold Consumer',
        icon: 'fa fa-globe'
      }
    }]
  },
  {
    path: '/trackntrace/registration/repackage',
    component: Repackage,
    name: 'repackage',
    meta: {
      title: 'Repackage',
      icon: 'fa fa-sitemap'
    }
  },
  {
    path: '/trackntrace/registration/pos',
    component: Pos,
    name: 'pos',
    meta: {
      title: 'Point of Sale',
      icon: 'fa fa-usd'
    }
  },
  {
    path: '/trackntrace/shipments',
    component: ListShipments,
    name: 'listShipments',
    meta: {
      title: 'Shipments',
      icon: 'fa fa-ship'
    }
  },
  {
    path: '/trackntrace/shipment/new',
    component: EditShipment,
    name: 'newShipment',
    meta: {
      title: 'New shipment',
      icon: 'fa fa-ship',
      breadcrumb: [
        { path: '#/trackntrace/shipments', title: 'Shipments' }
      ]
    }
  },
  {
    path: '/trackntrace/shipment/:id/view',
    component: Shipment,
    name: 'shipment',
    meta: {
      title: 'Shipment {{params.id}}',
      icon: 'fa fa-ship',
      breadcrumb: [
        { path: '#/trackntrace/shipments', title: 'Shipments' }
      ]
    }
  },
  {
    path: '/trackntrace/shipment/:id/edit',
    component: EditShipment,
    name: 'editShipment',
    meta: {
      title: 'Edit shipment {{params.id}}',
      icon: 'fa fa-ship',
      breadcrumb: [
        { path: '#/trackntrace/shipments', title: 'Shipments' },
        { path: '#/trackntrace/shipment/{{params.id}}/view', title: 'Shipment {{params.id}}' }
      ]
    }
  },
  {
    path: '/trackntrace/shipments/receive/:code',
    component: ReceiveShipment,
    name: 'receiveShipment',
    meta: {
      title: 'Receive Shipment {{params.code}}',
      icon: 'fa fa-ship',
      breadcrumb: [
        { path: '#/trackntrace/shipments', title: 'Shipments' },
      ]
    }
  },
  {
    path: '/trackntrace/business-locations',
    component: BusinessLocations,
    name: 'businessLocations',
    meta: {
      title: 'Business Locations',
      icon: 'fa fa-compass'
    }
  },
  {
    path: '/trackntrace/business-locations/new',
    component: BusinessLocation,
    name: 'newBusinessLocation',
    meta: {
      title: 'New Business Location',
      icon: 'fa fa-compass',
      breadcrumb: [
        { path: '#/trackntrace/business-locations', title: 'Business locations' }
      ]
    }
  },
  {
    path: '/trackntrace/business-locations/:id',
    component: BusinessLocation,
    name: 'editBusinessLocation',
    meta: {
      title: 'Edit Business Location {{ params.id}}',
      icon: 'fa fa-compass',
      breadcrumb: [
        { path: '#/trackntrace/business-locations', title: 'Business locations' }
      ]
    }
  },
  {
    path: '/trackntrace/configuration/packages',
    component: PackageTypes,
    name: 'packageTypes',
    meta: {
      title: 'Packages',
      icon: 'fa fa-cubes'
    }
  },
  {
    path: '/trackntrace/configuration/packages/new',
    component: PackageEdit,
    name: 'packageNew',
    meta: {
      title: 'Add Package Type',
      icon: 'fa fa-cube',
      breadcrumb: [
        { path: '#/trackntrace/configuration/packages', title: 'Package types' }
      ]
    }
  },
  {
    path: '/trackntrace/configuration/packages/:id',
    component: PackageEdit,
    name: 'packageEdit',
    meta: {
      title: 'Edit Package Type {{ params.id}}',
      icon: 'fa fa-cube',
      breadcrumb: [
        { path: '#/trackntrace/configuration/packages', title: 'Package types' }
      ]
    }
  },
  {
    path: '/trackntrace/registration/enablecoderange',
    component: EnableCodeRange,
    name: 'enablecoderange',
    meta: {
      title: 'Enable Code Range',
      icon: 'fa fa-arrows-v'
    }
  },
  {
    path: '/trackntrace/registration/trackingevent',
    component: RegisterTrackingevent,
    name: 'registerTrackingevent',
    meta: {
      title: 'Register Tracking Event',
      icon: 'fa fa-truck'
    }
  },
  {
    path: '/trackntrace/dashboards/supplychainoverview',
    component: SupplyChainOverview,
    name: 'supplychainoverview',
    meta: {
      title: 'Supply Chain Overview',
      icon: 'fa fa-globe'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/trackntrace.js